import { CompanyDependenciesFactory } from "./dependencies.factory";

export const companyEpicDependencies = {
    companyService: CompanyDependenciesFactory.getCompanyService()
}
